module.exports = __webpack_public_path__ + "static/media/brand-refresh-nationwide.a6c13b16.svg";